<p-fieldset [toggleable]="false" class="mb-4 border-round-lg shadow-1" styleClass="bg-surface-50 border-1">
  <h2 class="text-xl font-semibold text-color mb-4 flex items-center gap-2">
    <i class="pi pi-home text-primary"></i>
    BIENVENIDO AL SISTEMA DE ATENCION EN LINEA
  </h2>

  <div class="mb-6 p-4 bg-surface border border-surface-border rounded-lg shadow-sm">
    <p class="text-color font-medium text-lg flex items-center gap-2">
      <i class="pi pi-info-circle text-blue-500"></i>
      A través de este sistema usted podrá:
    </p>

    <ul class="list-inside mt-3 space-y-2 text-surface-600 text-base">
      <li class="flex items-start gap-2">
        <i class="pi pi-check-circle text-primary mt-1"></i>
        Ingresar peticiones, quejas y reclamos.
      </li>

      <li class="flex items-start gap-2">
        <i class="pi pi-check-circle text-primary mt-1"></i>
        Consultar peticiones, quejas y reclamos.
      </li>
    </ul>
  </div>

  <p-fieldset legend="Registrar/Radicar PQRS por Documento:" [toggleable]="true" class="mb-4 border-round-lg shadow-1"
    styleClass="bg-surface-50 border-1 border-surface-300">
    <div class="col-span-12 md:col-span-6 lg:col-span-5 xl:col-span-4">

      @if (!captchaValido) {
      <form [formGroup]="formcaptcha" class="p-3 border-round-lg border-1 border-surface-300 shadow-1">
        <div class="flex items-center gap-2 mb-2">
          <img [src]="captchaImage" alt="Captcha" class="border rounded h-12" />
          <button type="button" pButton icon="pi pi-refresh" class="p-button-text p-button-sm" (click)="getCaptcha()">
          </button>
        </div>
        <div class="flex items-center gap-2 mb-2">
          <input type="text" formControlName="UserInput" placeholder="Captcha"
            class="p-inputtext w-32 border-2 border-surface-300 rounded-xl px-4 py-4" />
          <button type="button" pButton icon="pi pi-check" class="p-button-text" variant="outlined"
            (click)="validarCaptcha()">
          </button>
        </div>
        <small class="text-color-500 block mt-2">
          Debe validar el captcha para continuar
        </small>
      </form>
      }

      @if (captchaValido) {
      <form [formGroup]="formIdentificacion" class="col-span-12">
        <div class="grid grid-cols-12 gap-3 items-end">
          <div class="col-span-12 md:col-span-5 lg:col-span-4">
            <label for="Identificacion" class="font-semibold text-color-700 mb-1 block">
              Número de Identificación
            </label>
            <input type="number" formControlName="Identificacion" class="p-inputtext w-full border-2 border-surface-300 rounded-xl px-3 py-2
               focus:border-blue-600 focus:ring-2 focus:ring-blue-300 transition-all" />
          </div>
          <div class="col-span-12 md:col-span-7 lg:col-span-5">
            <div class="flex gap-2 flex-wrap">
              <p-button label="Consultar" icon="pi pi-search" (click)="onBuscarIdentificacion()"
                styleClass="p-button-outlined">
              </p-button>
              <p-button label="Registro de Usuario" icon="pi pi-user-plus" (click)="onRegistroUsuario()"
                styleClass="p-button-outlined">
              </p-button>
            </div>
          </div>
        </div>
      </form>
        <app-inbox class="w-full mt-2" [hidden]="!mostrarInbox" 
        [table]="(service.initialConfigTableSubject$ | async)" 
        [data]="(service.dataTableGenericSubject$ | async)"
        (onLazyLoad)="service.onLoadRecords($event)">
        <p-button label="Crear PQRS" icon="pi pi-plus"
        styleClass="ml-2 h-[32px] justify-center border-primary span-p-badge-primary" variant="outlined"
        (click)="newRegisterPqrs()" />
      </app-inbox>
      }

    </div>
  </p-fieldset>

  <p-fieldset legend="Consulta por radicado PQRS:" [toggleable]="true" class="mb-4 border-round-lg shadow-1"
    styleClass="bg-surface-50 border-1 border-surface-300">
    <div class="col-span-12 md:col-span-6 lg:col-span-5 xl:col-span-4">

      @if (!captchaValidoRadicado) {
      <form [formGroup]="formcaptchaRadicado" class="p-3 border-round-lg border-1 border-surface-300 shadow-1">
        <div class="flex items-center gap-2 mb-2">
          <img [src]="captchaImageRadicado" alt="Captcha" class="border rounded h-12" />
          <button type="button" pButton icon="pi pi-refresh" class="p-button-text p-button-sm"
            (click)="getCaptchaRadicado()">
          </button>
        </div>
        <div class="flex items-center gap-2 mb-2">
          <input type="text" formControlName="UserInputt" placeholder="Captcha"
            class="p-inputtext w-32 border-2 border-surface-300 rounded-xl px-4 py-4" />
          <button type="button" pButton icon="pi pi-check" class="p-button-text" variant="outlined"
            (click)="validarCaptchaRadicado()">
          </button>
        </div>
        <small class="text-color-500 block mt-2">
          Debe validar el captcha para continuar
        </small>
      </form>
      }

      @if (captchaValidoRadicado) {
      <form [formGroup]="formConsultaRadicado">
        <div class="grid grid-cols-12 md:grid-cols-6 lg:grid-cols-12 xl:grid-cols-12 gap-2">
          <div class="col-span-12 md:col-span-3 lg:col-span-2 xl:col-span-2">
            <label for="CodRadicado" class="font-semibold text-color-700 mb-1">
              Consultar por PQRS
            </label>
            <input type="text" formControlName="CodRadicado" class="p-inputtext w-full border-2 border-surface-300 rounded-xl px-3 py-2 
                   focus:border-blue-600 focus:ring-2 focus:ring-blue-300 transition-all" />
          </div>
          <div class="col-span-12 md:col-span-2 lg:col-span-1 xl:col-span-1 flex items-end">
            <p-button label="Consultar" variant="outlined" icon="pi pi-search" (click)="onBuscarRadicado()"
              class="p-button-outlined px-4 py-2 text-sm border-round-lg"></p-button>
          </div>
        </div>
      </form>
      }
    </div>
  </p-fieldset>
</p-fieldset>
